import React, { ReactNode, useState, useRef, useEffect } from 'react';
import { joinClasses } from '../../Utils/className.util';
import Text from '../Base/Text/Text';
import styles from './DropdownButton.module.scss';

interface Props {
	title: string;
	children: ReactNode;
	firstUpper?: boolean;
}

const DropdownButton = ({ title, children, firstUpper = false }: Props) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef<HTMLDivElement>(null);
	const buttonRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				!dropdownRef.current?.contains(event.target as Node) &&
				!buttonRef.current?.contains(event.target as Node)
			) {
				setIsOpen(false);
			}
		};

		if (isOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isOpen]);

	const handleToggle = () => {
		setIsOpen(prev => !prev);
	};

	return (
		<div className={styles.wrapper}>
			<div
				ref={buttonRef}
				className={joinClasses([styles.button, isOpen ? styles.active : ''])}
				onClick={handleToggle}>
				<div className={styles.title}>
					<Text tx={title} inline={true} firstUpper={firstUpper} />
				</div>
			</div>
			<div
				className={joinClasses([styles.menu, !isOpen && styles.hidden])}
				ref={dropdownRef}>
				{children}
			</div>
		</div>
	);
};

export default DropdownButton;
